<template>
  <div class="container">
    <div class="handle-box">
      <el-form :model="queryCondition" ref="queryCondition" label-width="120px" class="searchForm">
        <el-row>
          <el-col :span="24">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item :label="$t('settlementUnit.queryConditionSupplierCode')" prop="supplierCode">
                  <!--结算单位编码-->
                  <el-input v-model="queryCondition.supplierCode" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('settlementUnit.supplierNameCn')" prop="supplierNameCn">
                  <!--中文名称-->
                  <el-input v-model="queryCondition.supplierNameCn" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('settlementUnit.suppliernameEn')" prop="suppliernameEn">
                  <!--供应商英文名称-->
                  <el-input v-model="queryCondition.suppliernameEn" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!--供应商编码-->
                <el-form-item :label="$t('settlementUnit.groupCode')" prop="groupCode">
                  <el-input v-model.trim="queryCondition.groupCode" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-collapse-transition>
            <el-col :span="24" v-if="isShow">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item :label="$t('settlementUnit.groupShortName')" prop="groupShortName">
                    <!--供应商简称-->
                    <el-input v-model="queryCondition.groupShortName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('supplierManage.supplierType')" prop="supplierType">
                    <!--供应商类型-->
                    <ic-select clearable table="TM_UNIT_OF_ACCOUNT" field="TYPE" v-model="queryCondition.supplierType" style="width:100%"></ic-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('supplierManage.Category1')" prop="categoryOneName">
                    <el-select v-model="queryCondition.categoryOneName" clearable @change="changeCategory1()" style="width:100%">
                      <el-option :key="index" v-for="(item, index) in categoryList1" :label="item.name" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('supplierManage.Category2')" prop="categoryName">
                    <el-select v-model="queryCondition.categoryName" clearable style="width:100%">
                      <el-option :key="index" v-for="(item, index) in categoryList2" :label="item.name" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item :label="$t('common.status')" prop="status">
                    <!--状态-->
                    <ic-select clearable table="TM_UNIT_OF_ACCOUNT" field="STATUS" v-model="queryCondition.status" style="width:100%"></ic-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('settlementUnit.queryHistory')" prop="queryHistory">
                    <!--历史审批通过版本-->
                    <el-select v-model="queryCondition.queryHistory" :placeholder="$t('common.sel')" clearable style="width:100%">
                      <el-option :label="$t('common.yes')" value="Y"></el-option>
                      <el-option :label="$t('common.no')" value="N"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="注册日期(从)" prop="beginDate">
                    <el-date-picker v-model="queryCondition.beginDate" type="date" value-format="yyyy-MM-dd" :placeholder="$t('common.selDate')" :picker-options="pickerOptionsStart" style="width:100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="注册日期(至)" prop="endDate">
                    <el-date-picker v-model="queryCondition.endDate" type="date" value-format="yyyy-MM-dd" :placeholder="$t('common.selDate')" :picker-options="pickerOptionsEnd" style="width:100%"></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item :label="$t('settlementUnit.isStart')" prop="canUsed">
                    <!--是否启用-->
                    <!-- <ic-select clearable table="COMMON" field="STATUS_DISABLE_ENABLE" v-model="queryCondition.processNode"></ic-select> -->
                    <el-select v-model="queryCondition.canUsed" :placeholder="$t('common.sel')" clearable style="width:100%">
                      <el-option :label="$t('settlementUnit.enabled')" value="1"></el-option>
                      <el-option :label="$t('settlementUnit.disabled')" value="0"></el-option>
                      <el-option label="已淘汰" value="2"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-collapse-transition>
        </el-row>
        <el-row type="flex" justify="center" align="middle">
          <el-button size="mini" @click="queryData(1)" type="primary">{{ $t('common.search') }}</el-button>
          <el-button size="mini" @click="restQueryForm()" type="primary">{{ $t('common.reset') }}</el-button>
          <span class="arrowDown" @click="isShow = !isShow">{{ isShow ? '收缩' : '展开' }}<i :class="isShow ? 'el-icon-arrow-up iconBtn' : 'el-icon-arrow-down iconBtn'"></i></span>
        </el-row>
      </el-form>
    </div>

    <div class="action-btn-row">
      <el-button size="mini" class="btn" type="primary" v-if="isShowFunc && !isEmplFlag" @click="addSupplier('SUP')" v-acl="SubmitUnitOfAccount">{{ $t('common.addNew') }}</el-button>
      <el-button size="mini" class="btn" type="primary" v-if="isShowFunc && isEmplFlag" @click="addSupplier('MDM')" v-acl="SubmitUnitOfAccount">{{ $t('settlementUnit.MDMAdd') }}</el-button><!-- MDM新增 -->
      <el-button size="mini" class="btn" type="danger" v-if="isShowFunc" @click="delSupplier" v-acl="DeleteUnitOfAccount">{{ $t('common.del') }}</el-button>
      <el-button size="mini" class="btn" type="primary" v-if="isGroup" @click="onGrouping">结算单位分组</el-button>
    </div>
    <el-table :data="tableList" ref="tableList" border highlight-current-row max-height='420' row-key="tmUserId">
      <el-table-column align="center" width="56" :label="$t('common.select')">
        <template slot-scope="scope">
          <!-- 待完善 新建可删除 -->
          <el-radio :disabled="scope.row.status != 'draft'" v-model="radioVal" @change.native="getSelectRow(scope.row)" :label="scope.row.tmUnitOfAccountId">&nbsp;
          </el-radio>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="supplierCode" :label="$t('settlementUnit.queryConditionSupplierCode')" min-width="100">
        <!-- 供应商编码 -->
        <template slot-scope="scope">
          <div class="a-link" @click="toDetail(scope.row)">{{ scope.row.supplierCode ? scope.row.supplierCode : '待MDM补充' }}
          </div>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="supplierNameCn" :label="$t('settlementUnit.supplierNameCn')" min-width="130"></el-table-column>
      <el-table-column show-overflow-tooltip prop="supplierNameEn" :label="$t('settlementUnit.suppliernameEn')" min-width="130"></el-table-column>
      <el-table-column show-overflow-tooltip prop="groupCode" :label="$t('settlementUnit.groupCode')" min-width="100"></el-table-column>
      <el-table-column show-overflow-tooltip prop="groupShortName" :label="$t('settlementUnit.groupShortName')" min-width="110"></el-table-column>
      <el-table-column show-overflow-tooltip prop="type" :label="$t('supplierManage.supplierType')" min-width="100">
        <template slot-scope="scope">{{ scope.row.type | ic('TM_SUPPLIER', 'GROUP_TYPE') }}</template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="address" :label="$t('settlementUnit.address')" min-width="110"></el-table-column><!-- 供应商地址 -->
      <el-table-column show-overflow-tooltip prop="categoryName" :label="$t('settlementUnit.supplierCategory')" min-width="110"></el-table-column>
      <el-table-column show-overflow-tooltip prop="createDate" :label="$t('settlementUnit.registerDate')" min-width="90"></el-table-column>
      <el-table-column show-overflow-tooltip prop="canUsed" :label="$t('settlementUnit.isStart')" :formatter="formatCanUsed" min-width="70"></el-table-column>
      <el-table-column show-overflow-tooltip prop="nodeName" :label="$t('settlementUnit.nodeName')" min-width="80"></el-table-column>
      <el-table-column show-overflow-tooltip prop="status" :label="$t('common.status')" min-width="80">
        <template slot-scope="scope">{{ scope.row.status | ic("TM_UNIT_OF_ACCOUNT", "STATUS") }}</template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
    </div>
    <el-dialog class="group_dialog" :visible.sync="dialogVisible" title="编辑结算单位分组" width="1200" :close-on-click-modal="false" @close="closeDialog">
      <div class="groupClass">
        <el-form :model="unitForm" ref="unitForm" class="unitForm">
          <el-row class="action-btn-row">
            <el-button size="mini" type="primary" @click="saveGroup()">{{ $t("common.save") }}</el-button>
          </el-row>
          <el-row gutter="20">
            <el-col :span="12">
              <div class="left_group">
                <el-row>
                  <span>结算单位分组</span>
                </el-row>
                <el-row style="margin:5px 0">
                  <el-button size="mini" type="primary" @click="addGroup">{{ $t('base.supplier.addGroup') }}</el-button>
                  <el-button size="mini" type="danger" @click="delGroup">{{ $t('common.del') }}</el-button>
                </el-row>
                <el-table ref="groupUnitTable" :data="unitForm.groupLists" :row-key="tmUnitGroupId" @current-change="changeCurrentGroup" @select="changeCurrentRow" highlight-current-row @selection-change="handleSelectionChange1" border>
                  <el-table-column type="selection" width="55"></el-table-column>
                  <el-table-column show-overflow-tooltip prop="unitGroupNo" :label="$t('base.supplier.groupCode')">
                    <template slot-scope="scope">
                      <el-form-item :prop="'groupLists.' + scope.$index + '.unitGroupNo'" :rules="unitGroupNoRules(scope.$index, scope.row)">
                        <el-input maxlength="20" v-model="scope.row.unitGroupNo" @blur="unitGroupNoBlur(scope.row.unitGroupNo)"></el-input>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column show-overflow-tooltip prop="unitGroupName" :label="$t('base.supplier.groupName')">
                    <template slot-scope="scope">
                      <el-form-item :prop="'groupLists.' + scope.$index + '.unitGroupName'" :rules="unitGroupNameRules(scope.$index, scope.row)">
                        <el-input maxlength="100" v-model="scope.row.unitGroupName"></el-input>
                      </el-form-item>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="rg_group">
                <el-row>
                  <span>结算单位</span>
                </el-row>
                <el-row style="margin:5px 0">
                  <el-button size="mini" type="primary" @click="addUnit">{{ $t('common.add') }}</el-button>
                  <el-button size="mini" type="danger" @click="onDel">{{ $t('common.del') }}</el-button>
                </el-row>
                <el-table ref="groupUnit" :data="groupUnitLists" @selection-change="handleSelectionChange2" border>
                  <el-table-column type="selection" width="55"></el-table-column>
                  <el-table-column show-overflow-tooltip prop="supplierCode" label="结算单位编号"></el-table-column>
                  <el-table-column show-overflow-tooltip prop="supplierName" label="结算单位名称"></el-table-column>
                </el-table>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-dialog>
    <!-- 结算单位 -->
    <el-dialog class="group_dialog" :visible.sync="dialogVisible1" title="结算单位" width="60%" :close-on-click-modal="false" @close="closeDialog1">
      <el-form :model="addForm" ref="addForm" label-width="130px" label-position="right">
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="结算单位编码" prop="supplierCode">
              <el-input v-model.trim="addForm.supplierCode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="结算单位名称" prop="supplierName">
              <el-input v-model.trim="addForm.supplierName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center" style="margin-bottom:10px">
          <el-button size="mini" @click="onSearch" type="primary">{{ $t('common.search') }}</el-button>
          <el-button size="mini" @click="onReset" type="primary">{{ $t('common.reset') }}</el-button>
        </el-row>
      </el-form>
      <div class="action-btn-row">
        <el-button size="mini" class="btn" type="primary" @click="onConfirm">选择</el-button>
      </div>
      <el-table ref="groupTable" :data="groupUnitTable" @selection-change="handleSelectionChange3" highlight-current-row border>
        <el-table-column type="selection" :selectable="isSelectable" label="选择" width="55"></el-table-column>
        <el-table-column show-overflow-tooltip prop="supplierCode" label="结算单位编码"></el-table-column>
        <el-table-column show-overflow-tooltip prop="supplierName" label="结算单位名称"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="pageSizeChange1" @current-change="currentPageChange" :current-page="addForm.pageNum" :page-sizes="pageSizeList" :page-size="addForm.pageSize" :layout="pageLayout" :total="total"></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { apiService } from "@/api/material/material-master-data";
import IcSelect from "@/components/common/icSelect";
import unitApi from "@/api/unit/unit";
import commonFunction from "@/utils/dataTableUtils";
import commonFun from "@/utils/commonFun";
import { Message } from "element-ui";

export default {
  components: { IcSelect },
  name: "",

  data() {
    return {
      dialogVisible: false,//结算单位分组显示
      dialogVisible1: false,//查询结算单位
      unitForm: {
        groupLists: [],//结算单位分组列表
      },
      multipleSelection1: [],//结算单位分组列表多选
      multipleSelection2: [],//结算单位列表多选
      groupUnitLists: [],//结算单位列表
      //结算单位查询
      addForm: {
        supplierCode: "",
        supplierName: "",
        pageNum: 1,
        pageSize: 15,
      },
      groupUnitTable: [],//结算单位查询列表
      radioVal: "",
      total: null,
      categoryList2: [],
      queryCondition: {
        supplierCode: "",
        supplierNameCn: '',
        suppliernameEn: '',
        groupCode: '',
        groupShortName: '',
        supplierType: '',
        categoryOneName: '',
        categoryName: '',
        status: '',
        queryHistory: "",
        beginDate: '',
        endDate: '',
        canUsed: '',
        homeOrAbroad: '',
        pageNum: 1, //当前页
        pageSize: 15, //每页多少条
      },
      isShow: false,//控制查询列表收缩展开
      tableList: [],
      radioVal: null,
      selectRow: null,
      pickerOptionsStart: {
        // 开始时间小于结束时间
        disabledDate: time => {
          let endTime = this.queryCondition.endDate;
          if (endTime) {
            return time.getTime() > new Date(endTime).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginTime = this.queryCondition.beginDate;
          if (beginTime) {
            return time.getTime() < new Date(beginTime).getTime() - 24 * 60 * 60 * 1000;
          }
        }
      },
      currentGroupId: null,
      selectRows: [],
      tmUnitGroupIds: [],
      exsitIds: [],
      rules: {},
      isShowFunc: true,
      isGroup: true,
      isEmplFlag: true,
    };
  },
  created() {
    //用户所属系统(SUP供应商)
    const emplFlag = localStorage.getItem("ms_emplFlag");
    //供应商用户
    if (emplFlag === 'SUP') {
      this.emplFlag = 'SUP';
    } else {
      let permission = JSON.parse(localStorage.getItem("ms_Permission"));
      for (let i = 0, len = permission.length; i < len; i++) {
        if (permission[i] == 'IS_MDM') {
          this.emplFlag = 'MDM';
        }
      }
    }
    this.queryData();
    this.getCategoryList()
  },
  computed: {
    currentGroupIndex() {
      console.log('currentGroupId111', this.currentGroupId);
      console.log('groupLists', this.unitForm.groupLists);
      let currentGroupId = this.currentGroupId;
      let currentGroupIndex = null;
      this.unitForm.groupLists.forEach((ele, index) => {
        if (ele.tmUnitGroupId == currentGroupId) {
          currentGroupIndex = index;
        }
      })
      return currentGroupIndex;
    }
  },
  mounted() {
    let ms_roles = JSON.parse(localStorage.getItem("ms_roles"));
    console.log('ms_roles', ms_roles);
    let dataScope = JSON.parse(localStorage.getItem("ms_DataScope"));
    console.log('dataScope', dataScope);
    let groupableSupplier = localStorage.getItem("groupableSupplier")//true是HGS供应商
    const emplFlag = localStorage.getItem("ms_emplFlag");
    console.log('groupableSupplier', groupableSupplier);
    if (((!dataScope || (dataScope && dataScope == "GROUP_ADMIN")) && groupableSupplier == 'true') || ms_roles.indexOf('MDM_TEAM') !== -1) {
      this.isGroup = true
    } else {
      this.isGroup = false
    }
    console.log('isGroup', this.isGroup);
    if (groupableSupplier !== 'false') {
      this.isEmplFlag = false;
      if (dataScope) {
        if (dataScope.indexOf('SUPPLIER_GROUPING') !== -1 || dataScope.indexOf('MATERIALS_AND_FPA_MAINTAINER') !== -1 || dataScope.indexOf('MATERIALS_MAINTAINER') !== -1) {
          this.isShowFunc = false
        } else {
          this.isShowFunc = true
        }
      }
    } else {
      //供应商用户
      if (emplFlag === 'SUP') {
        this.isEmplFlag = false;
      } else {
        this.isEmplFlag = true;
      }
    }
    console.log('isEmplFlag', this.isEmplFlag);
    console.log('isShowFunc', this.isShowFunc);
  },
  methods: {
    unitGroupNoRules(index, row) {
      return (this.rules["unitGroupNo"] = [
        {
          validator: (rule, value, callback) => {
            // 验证不为空
            if (!value) {
              this.$my_message('请输入分组编号', 'error')
              return callback(new Error(' '));
            }
            var reg = /^[A-Za-z0-9]+$/
            if (!reg.test(value)) {
              this.$my_message('仅可输入英文加数字，长度20个字符以内', 'error')
              return callback(new Error(' '));
            }
            if (value.length > 20) {
              this.$my_message('仅可输入英文加数字，长度20个字符以内', 'error')
              return callback(new Error(' '));
            }
            callback();
          },
          trigger: "blur"
        }
      ]);
    },
    unitGroupNameRules(index, row) {
      return (this.rules["unitGroupName"] = [
        {
          validator: (rule, value, callback) => {
            // 验证不为空
            if (!value) {
              this.$my_message('请输入分组名称', 'error')
              return callback(new Error(' '));
            }
            callback();
          },
          trigger: "blur"
        }
      ]);
    },
    isSelectable(row, index) {
      return !row.isDisabled
    },
    // 结算单位分组按钮
    onGrouping() {
      this.dialogVisible = true
      this.currentGroupId = null;
      unitApi.queryGroups().then(res => {
        this.unitForm.groupLists = res.data;
        this.groupUnitLists = [];
      });
    },
    unitGroupNoBlur() {
      for (var i = 0; i < this.unitForm.groupLists.length - 1; i++) {
        for (var j = i + 1; j < this.unitForm.groupLists.length; j++) {
          if (this.unitForm.groupLists[i].unitGroupNo && this.unitForm.groupLists[j].unitGroupNo) {
            if (this.unitForm.groupLists[i].unitGroupNo === this.unitForm.groupLists[j].unitGroupNo) {
              Message.warning('结算单位分组编号' + this.unitForm.groupLists[i].unitGroupNo + '已存在,请检查!')
              return false
            }
          }
        }
      }
      return true
    },
    // 结算分组保存
    saveGroup() {
      var bol = this.unitGroupNoBlur()
      console.log('bol', bol);
      if (!bol) {
        return false
      }
      this.$refs['unitForm'].validate((valid) => {
        if (valid) {
          let groups = this.unitForm.groupLists.map(group => {
            group.tmUnitGroupId = group.tmUnitGroupId < 0 ? null : group.tmUnitGroupId;
            // group.tmUnitGroupId = group.suppliers.map(sup => sup.tmSupplierId);
            return group;
          });
          unitApi.saveGroups(this.unitForm.groupLists).then(res => {
            Message.success(this.$t('common.saveSuccess'))
            this.onGrouping();
          });
        }
      })
    },
    // 添加分组
    addGroup() {
      var obj = {
        unitGroupNo: "",
        unitGroupName: "",
        suppliers: [],
        tmUnitGroupId: -new Date().getTime(),
      }
      this.unitForm.groupLists.push(obj)
    },
    // 删除分组
    delGroup() {
      let selection = this.tmUnitGroupIds;
      if (commonFun.isEmpty(selection)) {
        Message.error(this.$t('common.pleaseSelectData'));
        return;
      } else {
        this.$confirm(this.$t('common.delConfirm'), this.$t('common.tips'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          customClass: 'colorBtn',
          type: 'warning'
        }).then(() => {
          unitApi.deleteGroups(this.tmUnitGroupIds).then(res => {
            if (res.code === '200') {
              this.onGrouping()
              Message.success('删除成功')
            } else {
              Message.error(res.msg)
            }
          });
        });
      }
    },
    // 结算单位分组多选
    handleSelectionChange1(val) {
      this.tmUnitGroupIds = []
      this.multipleSelection1 = val;
      val.forEach(ele => {
        this.tmUnitGroupIds.push(ele.tmUnitGroupId)
      })
    },
    handleSelectionChange2(val) {
      this.multipleSelection2 = val;
    },
    changeCurrentRow(selection, row) {
      console.log('row11111111111111', row);
      this.$refs.groupUnitTable.setCurrentRow(row);
    },
    changeCurrentGroup(row) {
      console.log('currentGroupIndex', this.currentGroupIndex);
      console.log('row', row);
      if (commonFun.isNotEmpty(row)) {
        this.currentGroupId = row.tmUnitGroupId;
        this.groupUnitLists = this.unitForm.groupLists[this.currentGroupIndex].suppliers;
      }
    },
    // 结算单位添加
    addUnit() {
      if (commonFun.isEmpty(this.currentGroupIndex)) {
        Message.error(this.$t("base.supplier.pleaseSelectGroup"));
        return;
      }
      this.setDisabled().then(res => {
        this.queryGroupData()
      })
      this.dialogVisible1 = true
    },
    setDisabled() {
      this.exsitIds = []
      return new Promise((resolve, reject) => {
        this.unitForm.groupLists.forEach(ele => {
          if (ele.suppliers.length > 0) {
            ele.suppliers.forEach(el => {
              this.exsitIds.push(el.tmSupplierId)
            })
          }
        })
        resolve(this.exsitIds)
      })
    },
    // 结算单位删除
    onDel() {
      let selection = this.multipleSelection2;
      if (commonFun.isEmpty(selection)) {
        Message.error(this.$t('common.pleaseSelectData'));
        return;
      } else {
        this.$confirm(this.$t('common.delConfirm'), this.$t('common.tips'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          customClass: 'colorBtn',
          type: 'warning'
        }).then(() => {
          let oldSuppliers = this.unitForm.groupLists[this.currentGroupIndex].suppliers;
          oldSuppliers = oldSuppliers.filter(supItem => {
            return !selection.some(row => row.tmSupplierId == supItem.tmSupplierId)
          });
          this.unitForm.groupLists[this.currentGroupIndex].suppliers = oldSuppliers;
          this.groupUnitLists = oldSuppliers;
          Message.success('删除成功')
        });
      }
    },
    onCancel() {
      this.dialogVisible1 = false
      this.addForm = {
        supplierCode: "",
        supplierName: "",
        pageNum: 1,
        pageSize: 15,
      }
    },
    queryGroupData() {
      unitApi.getUnitOfAccounts(this.addForm).then(res => {
        this.groupUnitTable = res.data.records
        if (this.exsitIds.length > 0) {
          this.groupUnitTable.forEach(ele => {
            if (this.exsitIds.includes(ele.tmSupplierId)) {
              this.$set(ele, 'isDisabled', true)
            } else {
              this.$set(ele, 'isDisabled', false)
            }
          })
        }
        this.total = res.data.total;
      });
    },
    // 结算单位弹框查询
    onSearch() {
      this.queryGroupData()
    },
    handleSelectionChange3(val) {
      this.selectRows = val
    },
    onConfirm() {
      if (this.selectRows.length == 0) {
        this.$message({ message: "请选择结算单位", type: "warning" });
      } else {
        let oldSuppliers = this.unitForm.groupLists[this.currentGroupIndex].suppliers;
        if (commonFun.isEmpty(oldSuppliers)) {
          oldSuppliers = [];
        }
        oldSuppliers.push(...this.selectRows);
        oldSuppliers = commonFun.distinct(oldSuppliers, (supplier) => supplier.tmSupplierId);
        this.groupUnitLists = oldSuppliers;
        this.unitForm.groupLists[this.currentGroupIndex].suppliers = oldSuppliers;
        this.dialogVisible1 = false;
      }
    },
    // 结算单位弹框重置
    onReset() {
      this.addForm = {
        supplierCode: "",
        supplierName: "",
        pageNum: 1,
        pageSize: 15,
      }
      this.$refs.groupTable.clearSelection();
      this.queryGroupData()
    },
    pageSizeChange1(val) {
      this.addForm.pageSize = val;
      this.queryGroupData();
    },
    currentPageChange(val) {
      this.addForm.pageNum = val;
      this.queryGroupData();
    },
    // 关闭
    closeDialog() {
      this.dialogVisible = false
      this.$refs['unitForm'].resetFields();
    },
    closeDialog1() {
      this.dialogVisible1 = false
    },
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      if (this.emplFlag == 'SUP') {
        this.queryCondition.tmSupplierId = JSON.parse(localStorage.getItem("supplierObj")).tmSupplierId
      }
      let that = this;
      unitApi.getUnitList(this.queryCondition).then(res => {
        that.tableList = res.data.records;
        that.totalCount = res.data.total;
      });
    },
    restQueryForm() {
      this.$refs.queryCondition.resetFields();
      this.queryCondition = {
        supplierCode: "",
        supplierNameCn: '',
        suppliernameEn: '',
        groupCode: '',
        groupShortName: '',
        supplierType: '',
        categoryOneName: '',
        categoryName: '',
        status: '',
        queryHistory: "",
        beginDate: '',
        endDate: '',
        canUsed: '',
        homeOrAbroad: '',
        pageNum: 1, //当前页
        pageSize: 15, //每页多少条
      }
      this.queryData();
    },
    toDetail(row) {
      console.log("🚀 ~ toDetail ~ row:", row)
      if (row.type == "CARRIER") {
        this.$router.push({
          path: `/SupplierDataMaintenance/view`,
          query: { id: row.tmUnitOfAccountId, hasHistory: this.queryCondition.queryHistory }
        });
      } else {
        this.$router.push({
          path: `/SupplierDataMaintenance`,
          query: { id: row.tmUnitOfAccountId, hasHistory: this.queryCondition.queryHistory }
        });
      }

    },
    addSupplier(val) {
      this.$router.push({
        path: `/SupplierDataMaintenance`,
        query: { createType: val }
      });
    },
    delSupplier() {
      let that = this
      if (this.selectRow == null) {
        that.$message({
          message: this.$t("common.pleaseSelectOneData"),
          type: "success"
        });
      } else {
        //请确认是否删除!
        this.$confirm(this.$t('common.delConfirm'), this.$t('common.tips'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          cancelButtonClass: 'el-button--primary',
          confirmButtonClass: 'el-button--primary',
          type: 'warning'
        }).then(() => {
          let delId = this.selectRow.tmUnitOfAccountId;
          unitApi.deleteUnit(delId).then((res) => {
            if (res.code == 200) {
              this.selectRow = null;
              this.radioVal = null;
              that.$message({
                message: this.$t("common.delSuccess"),
                type: "success"
              });
              this.queryData();
            } else {
              that.$message({
                message: this.$t("common.delError"),
                type: "success"
              });
            }
          });
        }).catch(() => {
        });
      }
    },
    formatCanUsed: function (row) {
      return row.canUsed == 0 ? "已禁用" : row.canUsed == 2 ? "已淘汰" : "已启用";
    },
    //单选操作
    getSelectRow: function (row) {
      this.selectRow = [];
      this.selectRow = row;
    },
    getCategoryList() {
      apiService.findCategory({ categoryLevel: 1 }).then((res) => {
        this.categoryList1 = res.data;
      });
    },
    //根据选中Category1查询Category2
    changeCategory1() {
      this.queryCondition.categoryName = null
      this.categoryList2 = []
      apiService.findCategory({ categoryLevel: 2, pid: this.queryCondition.categoryLevel1Id }).then((res) => {
        this.categoryList2 = res.data;
      });
    },
  },
  extends: commonFunction
};
</script>
<style lang="scss">
.unitForm {
  .el-form-item--mini.el-form-item,
  .el-form-item--small.el-form-item {
    margin-bottom: 0 !important;
  }
}
</style>
